import React from "react";

export default function HelpModal(props: { onClick: () => void }) {
  return (
    <div
      className="modal w-full h-full top-0 left-0 flex fixed pointer-events-none opacity-0 items-center justify-center z-20"
      id="help-submenu-modal"
    >
      <div
        className="modal-background absolute w-full h-full bg-gray-900 opacity-40"
        onClick={props.onClick}
      />
      <div
        className="modal-close cursor-pointer z-50 fixed top-4 right-4"
        onClick={props.onClick}
      >
        <svg
          className="fill-current text-white"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
        </svg>
      </div>

      <div className="modal-container bg-white w-120 px-6 py-3 rounded-xl shadow-2xl z-20 overflow-y-auto m-1">
        <p className=" rounded-t p-1 font-semibold text-center text-4xl">
          ECE Iris Help <i className="fa-md fa fa-question-circle"></i>
          <iframe
            className="m-5"
            width="560"
            height="315"
            src="https://www.youtube-nocookie.com/embed/8yaMsG_g1X4"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          ></iframe>
        </p>
        <p className="text-blue-600 underline">
          <a href="https://forms.office.com/pages/responsepage.aspx?id=JsKqeAMvTUuQN7RtVsVSECBwHwfOtNpLoqHwIsEDKhdUREUySktRR1hVQkxBQ0hDUVg5RDg2Qk9GSCQlQCN0PWcu">
            File a bug report or leave a comment!
          </a>
        </p>
      </div>
    </div>
  );
}
